import axios from "axios";
import authstore from '@/store/modules/auth';
import appstore from '@/store/modules/app';

/* global serverAddress */
const baseDomain = serverAddress;
const baseURL = `${baseDomain}`;


export default {
    getClient: async function() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + authstore.state.token
        return axios.create({
            baseURL,
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': appstore.state.language
            }
        });
    }
}